import { WrappedComponentProps } from 'react-intl';
import { View } from '@gin-betting/core';
import { getOutcomesFromOddNames } from '@gin-betting/table-view/outcomes';

import {
    MATCHES_LIMIT_PER_PAGE,
    MOBILE_MATCHES_LIMIT_PER_PAGE,
    NEWS_MATCHES_LIMIT_PER_PAGE,
} from 'app-constants';
import globalMessages from 'messages';
import UserDevice from 'services/user-device';
import { checkIfNewsPage } from 'utils';

type Odds = Array<View.Odd | Pick<View.Odd, 'id' | 'name'>>;

interface OverUnder {
    over: Odds[number];
    under: Odds[number];
}

export const getOverAndUnderOdds = (
    odds: Odds,
    formatMessage: WrappedComponentProps['intl']['formatMessage']
): OverUnder => {
    return {
        ...findByKey({
            key: 'over',
            odds,
            formatMessage,
        }),
        ...findByKey({
            key: 'under',
            odds,
            formatMessage,
        }),
    };
};

function findByKey<K extends keyof OverUnder>({
    key,
    odds,
    formatMessage,
}: {
    key: K;
    odds: Odds;
    formatMessage: WrappedComponentProps['intl']['formatMessage'];
}): Pick<OverUnder, K> {
    // NOTE:
    // ATTENTION: Message from intl should be equal with odd outcome otherwise total market ignored
    const msg = formatMessage(globalMessages[key]);

    // TODO: don't mutate "odds"
    const overUnderOdd = odds.find(odd => {
        const [outcome] = getOutcomesFromOddNames([odd], null);

        if (!outcome) return false;

        const isOverUnderOdd = [msg, key]
            .map(str => str.toLowerCase())
            .includes(outcome.toLowerCase());

        if (isOverUnderOdd) {
            odd.name = outcome;
        }

        return isOverUnderOdd;
    }) ?? { id: '', name: msg };

    return {
        [key]: overUnderOdd,
    } as any;
}

export const getMatchesLimitPerPage = () =>
    checkIfNewsPage()
        ? NEWS_MATCHES_LIMIT_PER_PAGE
        : UserDevice.getInstance()?.isDeviceMobile()
        ? MOBILE_MATCHES_LIMIT_PER_PAGE
        : MATCHES_LIMIT_PER_PAGE;
